var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyToClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy 1",
    clipPath: "url(#clip0_249_2088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.46162 8.93749C3.38773 8.93749 2.51367 8.06343 2.51367 6.98955V2.29169H1.71162C1.01631 2.29169 0.451172 2.85674 0.451172 3.55205V9.73955C0.451172 10.4349 1.01631 11 1.71162 11H7.44073C8.13603 11 8.70117 10.4349 8.70117 9.73955V8.93749H4.46162Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5345 1.26044C10.5345 0.564217 9.97026 0 9.27412 0H4.46162C3.76539 0 3.20117 0.564217 3.20117 1.26044V6.98956C3.20117 7.68578 3.76539 8.25 4.46162 8.25H9.27412C9.97026 8.25 10.5345 7.68578 10.5345 6.98956V1.26044Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_2088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToClipboard);
export default __webpack_public_path__ + "static/media/copy-to-clipboard.8be670ec3244f7f5d97c9bcb71da23e0.svg";
export { ForwardRef as ReactComponent };